import type { Frame } from "../api/types";

/**
 * Build the download filename for a saved frame, matching the shared viewer's
 * capture-time name (`viewer.js` `fmtTimecode`): the frame's wall-clock time in
 * the flight's display timezone, e.g. `frame_18_39_02.jpg`. Falls back to the
 * frame id when the time can't be formatted, so the download never throws.
 *
 * @param tz IANA timezone (flight `displayTimezone`); omit for the runtime's
 *   local zone, mirroring `viewer.js`'s `meta.displayTimezone || <local>`.
 */
export function frameDownloadName(frame: Frame, tz?: string): string {
  const fallback = `${frame.id}.jpg`;
  if (!Number.isFinite(frame.utc) || frame.utc <= 0) return fallback;
  try {
    const clock = new Intl.DateTimeFormat("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
      timeZone: tz,
    })
      .format(new Date(frame.utc * 1000))
      .replace(/[: ]/g, "_");
    return `frame_${clock}.jpg`;
  } catch {
    return fallback;
  }
}
